/**
 * Separates search params into groups based on their encryptability. In order for a search param to
 * be encryptable it must be an object.
 * @param {object} searchParams The search params to separate into encodable and encryptable groups
 * @returns {object} An object containing paramsToEncode and paramsToEncrypt objects with the separated params
 */
export function separateEncryptableParams(searchParams = {}) {
  return Object.entries(searchParams).reduce(
    ({ encryptableParams, simpleParams }, [searchParamName, searchParamValue]) => {
      if (typeof searchParamValue === "object" && Object.keys(searchParamValue).length > 0) {
        encryptableParams[searchParamName] = searchParamValue;
      } else {
        simpleParams[searchParamName] = searchParamValue;
      }

      return { encryptableParams, simpleParams };
    },
    { encryptableParams: {}, simpleParams: {} }
  );
}

/**
 * Determines whether a group of search params include some that are intended to be encrypted.
 * @param {object} searchParams The search params to check for encryptable params
 * @returns {boolean} True if the search params contain an encryptable param and false otherwise
 */
export function containsParamsToEncrypt(searchParams) {
  const { encryptableParams } = separateEncryptableParams(searchParams);

  return Object.keys(encryptableParams).length > 0;
}
